import "./src/styles/global.css";

// GTM dataLayer'a niyet olaylari gonderir (Google Ads donusum takibi icin).
// register_click: app.onaylarim.com/register'a giden tum linkler (CTA, menu, blog)
// tool_download: indirmeler sayfasindaki Indir butonlari ve App Store linki
export const onClientEntry = () => {
    document.addEventListener(
        "click",
        (e) => {
            const anchor = e.target && e.target.closest ? e.target.closest("a[href]") : null;
            if (!anchor) return;
            const href = anchor.href || "";
            window.dataLayer = window.dataLayer || [];
            if (href.indexOf("app.onaylarim.com/register") !== -1) {
                window.dataLayer.push({ event: "register_click", link_url: href });
            } else if (
                window.location.pathname.indexOf("downloadsPage") !== -1 &&
                (anchor.textContent.trim() === "İndir" || href.indexOf("apps.apple.com") !== -1)
            ) {
                window.dataLayer.push({ event: "tool_download", link_url: href });
            }
        },
        true
    );
};
